export class ExpirationModalConfig {

  content: string;
  logOutEarly: string;
  stayLoggedIn: string;
  returnToLogin: string;
  title: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    logOutEarly?: string,
    stayLoggedIn?: string,
    returnToLogin?: string,
    title?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.logOutEarly = logOutEarly;
    this.stayLoggedIn = stayLoggedIn;
    this.returnToLogin = returnToLogin;
    this.title = title;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/expiration-modal/expiration-modal-config.ts